"use client";

import React from "react";
import { DrupalNode } from "next-drupal";
import Banner from "@/components/sections/Banner";
import { config } from "@/lib/config";
import Image from "next/image";

interface MissionEfficiencyPledgeScreenProps {
  data?: DrupalNode;
}

const MissionEfficiencyPledgeScreen: React.FC<
  MissionEfficiencyPledgeScreenProps
> = ({ data }: MissionEfficiencyPledgeScreenProps) => {
  return (
    <div className="pt-20">
      <Banner
        title={data?.field_title}
        subTitle={data?.field_sub_title}
        backgroundImg="/static/images/event-bg.png"
        buttonText={data?.field_button?.[0]?.title}
        buttonLink={data?.field_button?.[0]?.uri}
        button2Text={data?.field_button?.[1]?.title}
        button2Link={data?.field_button?.[1]?.uri}
        isRounded
      />

      <div className="mini-container py-[120px]">
        <div className="max-w-[200px] h-[100px] w-full mx-auto bg-white mb-16">
          <Image
            src={`${config.apiBase}${data?.field_icon?.uri?.url}`}
            alt="country flag"
            width={200}
            height={100}
            className="h-full w-full min-w-[250px] min-h-[100px] h-[100px] object-contain border-box px-2"
          />
        </div>

        <div
          className="--font-poppins news-article text-left text-[16px] text-[#828282] leading-7 mb-5 mobileMax:text-xsmall mobileMax:leading-normal"
          dangerouslySetInnerHTML={{
            __html: data?.field_description?.value || "",
          }}
        />
      </div>
    </div>
  );
};

export default MissionEfficiencyPledgeScreen;
